import { render, staticRenderFns } from "./Evaluation.vue?vue&type=template&id=32c152d5&scoped=true"
import script from "./Evaluation.vue?vue&type=script&lang=js"
export * from "./Evaluation.vue?vue&type=script&lang=js"
import style0 from "./Evaluation.vue?vue&type=style&index=0&id=32c152d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c152d5",
  null
  
)

export default component.exports